import React from 'react';

import './App.css';

// import Navigater from './Navigation/Navigater';

import { BrowserRouter as Router } from 'react-router-dom';

import AppRoutes from './AppRoutes';

function App() {

  return (
    <Router>
      {/* <Navigater /> */}
      <AppRoutes />
    </Router>
  );
}

export default App;